<template>
  <div class="container pt-5">

    <destination-page-template :destination-copy="destinationCopy" :assets="assets">
        <div slot="main-image" class="main-image mb-3" :style="`background-image: url(${mainImagePath})`"></div>
    </destination-page-template>

  </div>
</template>

<script>
  import {getDestinationCopy} from "../../constants/destination-copy";
  import {getDestinationAssets, getDestinationMainAsset} from "../../constants/destination-assets";
  import DestinationPageTemplate from "../../components/destination-page-template";

  export default {
    name: 'Madrid',
    components: {
      DestinationPageTemplate
    },
    computed: {
      mainImagePath: function () {
        return getDestinationMainAsset('madrid');
      },
      destinationCopy: function () {
        return getDestinationCopy('Madrid').copy;
      },
      assets: () => {
        return getDestinationAssets('madrid').assets;
      }
    }
  }
</script>

<style scoped lang="scss">
  .main-image {
    min-height: 500px;
    background-size: cover;
    background-position-x: right;
    background-position-y: center;
  }
</style>